import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './IggloProgressBar.scss';

// const archLengthPercent = 0.925;
// const startAngle = -1.335176877775662; // (Math.PI * (1 - archLengthPercent)) - (Math.PI / 2);
const startAngleCos = 0.23344536385590542;
const startAngleSin = -0.9723699203976766;
const endAngle = -0.23344536385590542; // Math.cos((Math.PI * archLengthPercent) + (Math.PI / 2))
const lengthMultiplier = 5.811946409141117; // (Math.PI * 2 * archLengthPercent);

function Arcs({ className, duration, progress, strokeWidth, trailWidth }) {
  const maxArchWidth = Math.max(strokeWidth, trailWidth);

  const r = 50 - (maxArchWidth / 2);
  const startX = 50 + (r * startAngleCos);
  const startY = 50 + (r * startAngleSin);
  const endY = 50 + (r * endAngle);
  const middleY = 50 + r;

  const length = r * lengthMultiplier;

  const d = `M ${startX},${startY} A ${r},${r} 0 0 1 50,${middleY} ${r},${r} 0 0 1 ${endY},${startY}`;

  return (
    <svg viewBox="0 0 100 100" className={className} styleName="arcs">
      <path
        style={{ strokeWidth: trailWidth }}
        d={d}
      />
      <path
        style={{
          strokeDashoffset: length * (1 - progress),
          strokeDasharray: length,
          transitionDuration: duration,
          strokeWidth
        }}
        d={d}
      />
    </svg>
  );
}

Arcs.propTypes = {
  className: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  trailWidth: PropTypes.number.isRequired
};

export default class IggloProgressBar extends PureComponent {
  constructor(props) {
    super(props);

    this.afterDOMRender = this::this.afterDOMRender;

    this.state = {
      duration: props.initialAnimate ? '0ms' : `${props.duration}ms`,
      progress: props.initialAnimate ? 0 : props.progress,
      initialAnimationDone: !props.initialAnimate
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      duration: `${nextProps.duration}ms`,
      progress: nextProps.progress
    };
  }

  afterDOMRender(ref) {
    if (ref && this.state.initialAnimationDone === false) {
      this.setState({
        duration: `${this.props.duration}ms`,
        progress: this.props.progress,
        initialAnimationDone: true
      });
    }
  }

  render() {
    return (
      <div
        className={this.props.className}
        styleName="root"
        style={this.props.style}
        ref={this.afterDOMRender}
      >
        <Arcs
          className={this.props.progressBarClassName}
          duration={this.state.duration}
          progress={this.state.progress}
          strokeWidth={this.props.strokeWidth}
          trailWidth={this.props.trailWidth}
        />

        <div className={this.props.childContainerClassName} styleName="children">
          { this.props.children }
        </div>
      </div>
    );
  }
}

IggloProgressBar.propTypes = {
  childContainerClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  duration: PropTypes.number,
  initialAnimate: PropTypes.bool,
  progressBarClassName: PropTypes.string,
  progress: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  trailWidth: PropTypes.number
};

IggloProgressBar.defaultProps = {
  childContainerClassName: '',
  children: null,
  className: '',
  initialAnimate: false,
  duration: 360,
  progressBarClassName: '',
  strokeWidth: 2,
  style: {},
  trailWidth: 4
};
